import { isToday, isTomorrow, format } from 'date-fns'

const locationBaseURL = 'https://schedule.perlmanclinic.com/schedule/?location='
const pediatricsBaseURL =
  'https://schedule.perlmanpediatrics.com/?location='

export const buildApptURL = (id: string, isPediatrics: boolean): string =>
  `${isPediatrics ? pediatricsBaseURL : locationBaseURL}${id}`

export const formatSlot = (slot: Date) => {
  if (isToday(slot)) {
    return format(slot, "'Today at' h:mmaaa")
  }
  if (isTomorrow(slot)) {
    return format(slot, "'Tomorrow at' h:mmaaa")
  }
  return format(slot, 'MMM dd, h:mmaaa')
}

export const isNumber = (value: string): boolean => /^-?\d+$/.test(value)

export const isValidZipcode = (value: string): boolean =>
  isNumber(value) && value.length === 5

const kmToMiles = (km: number): number => km * 0.62137

export const haversineCalculate = (
  latA: number,
  lonA: number,
  latB: number,
  lonB: number
): number => {
  const { PI, sin, cos, atan2 } = Math
  const r = PI / 180
  const R = 6371
  const deltaLat = (latB - latA) * r
  const deltaLon = (lonB - lonA) * r
  const a =
    sin(deltaLat / 2) ** 2 +
    cos(cos(latB * r) * latA * r) * sin(deltaLon / 2) ** 2
  const c = 2 * atan2(a ** 0.5, (1 - a) ** 0.5)
  const d = R * c
  return kmToMiles(d)
}

export const formatPhone = (phone: string): string =>
  `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`

export const buildDirectionsLink = (address: string, city: string, zip: string ): string => {
  // [PC-4282] Hotfix Regex to remove suite numbers (common formats like "Suite 200", "Ste 200", "#200").
  // Note that California is hardcoded, which is acceptable at time of writing.
  const sanitizedAddress = address.replace(/(Suite|Ste|STE|suite|#)\s*[\w-]+/gi, "").trim();
  const formattedAddress = `${sanitizedAddress}, ${city}, CA ${zip}`.trim();

  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(formattedAddress)}&travelmode=driving`;
}

function isDSTActive() {
  // Create a date object that is now
  const today = new Date()
  // Get the year as a number
  const thisYear = today.getFullYear()

  const todayTimezoneOffSet = today.getTimezoneOffset()

  const julyDate = new Date(thisYear, 6, 1);
  const julyTimezoneOffSet = julyDate.getTimezoneOffset();

  const isActive = julyTimezoneOffSet === todayTimezoneOffSet;

  return isActive;
}

export const toPT = (dt: Date): Date => {
  const dtDateOnly = new Date(dt.valueOf() + (dt.getTimezoneOffset() * 60 * 1000) + (isDSTActive() ? -7 : -8) * 60 * 60 * 1000)
  return dtDateOnly
}
